import { BaseCommand } from "./baseCommand";

export abstract class AbstractGlobalDataCommand extends BaseCommand {
}